import React from 'react';

/**
 * StatCard - shared bordered stat-card shell.
 *
 * Any extra props are spread onto the outer div, so callers can attach
 * data-testid or aria-* the way the per-page cards this replaced did.
 *
 * A white, rounded card with a colored left-border accent. All inner content
 * is caller-supplied via `children`, so it works for any stat/metric tile
 * (Dashboard statistics, Onboarding request counts, ...).
 *
 * @param {object} props
 * @param {string} [props.borderColor]  Left-border color class, e.g. 'border-primary-500'.
 * @param {string} [props.className]    Extra classes (padding/shadow/etc.), e.g. 'shadow-soft p-6'.
 * @param {React.ReactNode} props.children  Card contents.
 */
const StatCard = ({ borderColor = '', className = '', children, ...rest }) => (
  <div
    className={`bg-white rounded-lg border-l-4 ${borderColor} ${className}`.trim()}
    {...rest}
  >
    {children}
  </div>
);

export default StatCard;
